module.exports = __webpack_public_path__ + "static/img/default.b2b7f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default.jpg
// module id = ZTHz
// module chunks = 1